<template>
  <div class="timeline-item active">
    <div class="item-badge">{{ store.previousSteps.length + 1 }}</div>
    <div class="item-content">
      <h2>{{ store.currentStep.caption }}</h2>
      <div class="ekn-box text-left">
        <h3>{{ result.heading }}</h3>

        <p v-if="result.description">{{ result.description }}</p>

        <p v-if="result.disclaimer">{{ result.disclaimer }}</p>

        <a v-if="!result.hideResultPageLink" :href="result.resultPageLink" class="btn btn-primary button">
          {{ resultPageButtonText }}
        </a>

        <a v-if="result.showApplyOnlineButton" :href="applyOnlineButtonLink" class="btn btn-primary js-btn-apply button" target="_blank">{{ applyOnlineButtonText }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useWizardStepsStore } from "../store/wizardStepsStore";

const store = useWizardStepsStore();

const result = store.currentStep.wizardStepResultDto;

const resultPageButtonText = (document.getElementById("resultPageButtonText") as HTMLInputElement).value;
const applyOnlineButtonText = (document.getElementById("applyOnlineButtonText") as HTMLInputElement).value;
const applyOnlineButtonLink = (document.getElementById("applyOnlineButtonLink") as HTMLInputElement).value;
</script>